/* layal-commun.js : outils partagés de la page Layal (layout/layal.liquid), chargé avant les autres scripts Layal.
 *
 * window.Layal.formatMonnaie(centimes, format) : montant au format de la boutique (shop.money_format), espaces
 *   insécables comme dans la maquette (« 12,90 € »).
 * window.Layal.lignesPourLot(lot, couleurs) : lignes du panier d'une offre (Solo : la variante ; lot : le produit lot
 *   tarifé, une unité, coloris en propriétés « Coloris 1 »… ou noms des articles du lot).
 * window.Layal.ajouterAuPanier(lignes, declencheur) : vrai ajout au panier Shopify (POST /cart/add.js, une ligne par
 *   variante et composition : [{ id, quantity, properties? }]). Avec le tiroir panier du thème (assets/theme.js, window.SignatureCart) : file
 *   d'attente du thème, rendu du tiroir (Section Rendering), compteurs [data-cart-count] (dont celui du hero),
 *   ouverture du tiroir et annonce. Sans tiroir (panier en page) : redirection vers le panier.
 *   Renvoie une promesse ; en cas d'échec, l'erreur porte le message de Shopify (ex. stock insuffisant).
 */
(function () {
  "use strict";

  var Layal = window.Layal = window.Layal || {};

  function avecSeparateurs(centimes, decimales, milliers, decimale) {
    var n = (Number(centimes) || 0) / 100;
    var parties = n.toFixed(decimales).split(".");
    var entier = parties[0].replace(/\B(?=(\d{3})+(?!\d))/g, milliers);
    return entier + (parties[1] ? decimale + parties[1] : "");
  }

  Layal.formatMonnaie = function (centimes, format) {
    format = format || "{{amount_with_comma_separator}} €";
    var motif = /\{\{\s*(\w+)\s*\}\}/;
    var correspondance = format.match(motif);
    var valeur = "";
    switch (correspondance ? correspondance[1] : "amount_with_comma_separator") {
      case "amount": valeur = avecSeparateurs(centimes, 2, ",", "."); break;
      case "amount_no_decimals": valeur = avecSeparateurs(centimes, 0, ",", "."); break;
      case "amount_no_decimals_with_comma_separator": valeur = avecSeparateurs(centimes, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": valeur = avecSeparateurs(centimes, 2, "'", "."); break;
      case "amount_no_decimals_with_space_separator": valeur = avecSeparateurs(centimes, 0, " ", ","); break;
      case "amount_with_space_separator": valeur = avecSeparateurs(centimes, 2, " ", ","); break;
      case "amount_with_period_and_space_separator": valeur = avecSeparateurs(centimes, 2, " ", "."); break;
      default: valeur = avecSeparateurs(centimes, 2, ".", ",");
    }
    return format.replace(motif, valeur).replace(/<[^>]*>/g, "").trim().replace(/ /g, " ");
  };

  function routeAjout() {
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return racine + "cart/add.js";
  }
  function routePanier() {
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return racine + "cart";
  }

  // La composition fait partie de l'identité : deux lots de coloris différents restent deux lignes.
  Layal.regrouper = function (lignes) {
    var ordre = [], parId = Object.create(null);
    lignes.forEach(function (l) {
      if (!l || !l.id) return;
      var proprietes = Object.create(null);
      Object.keys(l.properties || {}).sort().forEach(function (nom) {
        if (l.properties[nom] != null) proprietes[nom] = String(l.properties[nom]);
      });
      var cle = JSON.stringify([String(l.id), proprietes]);
      if (!parId[cle]) {
        parId[cle] = { id: Number(l.id), quantity: 0 };
        if (Object.keys(proprietes).length) parId[cle].properties = proprietes;
        ordre.push(cle);
      }
      parId[cle].quantity += Number(l.quantity) || 1;
    });
    return ordre.map(function (cle) { return parId[cle]; });
  };

  // Le tarif reste celui de Shopify : une unité d'un produit lot, avec les coloris pour la préparation.
  // Propriétés : « Coloris 1 », « Coloris 2 »… ou les noms des articles du lot (lot.articles, ex. « Voile »,
  // « Maintien » pour le kit). couleurs[i] : coloris de l'article i (celui de l'autre produit pour un kit).
  Layal.lignesPourLot = function (lot, couleurs) {
    var q = Number(lot.quantite) || 1;
    if (q < 1 || q > 5 || q % 1) throw new Error("Cette offre n'est pas disponible."); // jusqu'à 5 (formules extensibles)
    if (q > 1 && (!lot.varianteLot || lot.disponible !== true)) {
      throw new Error("Cette offre n'est pas disponible pour le moment. Choisissez une autre offre.");
    }
    var proprietes = {};
    for (var i = 0; i < q; i++) {
      if (!couleurs[i] || !couleurs[i].variante || !couleurs[i].nom) {
        throw new Error("Choisissez un coloris pour chaque article.");
      }
      var nomArticle = lot.articles && lot.articles[i] ? String(lot.articles[i]) : "Coloris " + (i + 1);
      proprietes[nomArticle] = couleurs[i].nom;
    }
    if (q === 1) return [{ id: couleurs[0].variante, quantity: 1 }];
    return [{ id: lot.varianteLot, quantity: 1, properties: proprietes }];
  };

  Layal.ajouterAuPanier = function (lignes, declencheur) {
    var items = Layal.regrouper(lignes);
    if (!items.length) return Promise.reject(new Error("Aucun article à ajouter."));
    if (window.SignatureCart && typeof window.SignatureCart.addItems === "function") {
      return window.SignatureCart.addItems(items, declencheur);
    }
    // Repli (script du thème absent) : ajout direct, puis page panier.
    return fetch(routeAjout(), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (reponse) {
      return reponse.json().catch(function () { return {}; }).then(function (donnees) {
        if (!reponse.ok || donnees.status) {
          throw new Error(donnees.description || donnees.message || "Le panier n'a pas pu être mis à jour. Réessayez dans un instant.");
        }
        window.location.href = routePanier();
        return donnees;
      });
    });
  };

  Layal.lireJson = function (element) {
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (e) {
      if (window.console) console.error("Layal : JSON illisible", e);
      return null;
    }
  };

  // Couleur choisie -> ?variant=<id> dans l'adresse (sans recharger ni ajouter d'entrée à l'historique).
  Layal.majUrlVariante = function (idVariante) {
    if (!idVariante) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", String(idVariante));
      url.searchParams.delete("couleur");
      window.history.replaceState(window.history.state, "", url.toString());
    } catch (e) { /* contexte restreint : on ignore */ }
  };
})();
